import fetchApi from 'services/api/connector';

export const fetchAllUserAgents = () => fetchApi(`agents/filter?q=${escape(JSON.stringify({}))}`, { method: 'GET' });
export const fetchAllCloudAgents = () => fetchApi(`cloud_agents/filter?q=${escape(JSON.stringify({}))}`, { method: 'GET' });
export const fetchUserAgents = (queryParam) => fetchApi(`agents/filter?q=${escape(JSON.stringify(queryParam))}`, { method: 'GET' });
export const fetchCloudAgents = (queryParam) => fetchApi(`cloud_agents/filter?q=${escape(JSON.stringify(queryParam))}`, { method: 'GET' });
export const removeAgent = (id) => fetchApi(`agents/${id}`, { method: 'DELETE' });
export const removeAgents = (ids) => fetchApi('agents', { method: 'DELETE', data: { ids } });
export const fetchToken = (data) => fetchApi('agent_token', {
  method: 'GET',
  headers: { 'Content-Type': 'multipart/form-data' },
  data
});
export const fetchAgentData = (id) => fetchApi(`agents/${id}`);

export const fetchCloudAgentData = (id) => fetchApi(`cloud_agents/${id}`);

export const runUserAgentTool = (agentId, payload) => fetchApi(`agents/${agentId}/run`, {
  method: 'POST',
  headers: { 'Content-type': 'application/json' },
  data: { ...payload }
});

export const changeStateAgent = (agentId, payload) => fetchApi(`agents/${agentId}`, {
  method: 'PUT',
  headers: { 'Content-type': 'application/json' },
  data: { ...payload }
});

export const getAgentsList = () => fetchApi('agents', { method: 'GET' });

export const runCloudAgent = (agentId, payload) => fetchApi(`cloud_agents/${agentId}/run`, {
  method: 'POST',
  headers: { 'Content-type': 'application/json' },
  data: { ...payload }
});

export const getActiveAgents = () => fetchApi('agents/active_agents', { method: 'GET' });

export const fetchCloudAgent = (id) => fetchApi(`cloud_agents/${id}`, { method: 'GET' });
export const saveToolData = (payload) => fetchApi('agents/save_parameters', {
  method: 'POST',
  headers: { 'Content-type': 'application/json' },
  data: { ...payload }
});

export const saveCloudAgents = (payload) => fetchApi('cloud_agents/save_parameters', {
  method: 'POST',
  headers: { 'Content-type': 'application/json' },
  data: { ...payload }
});

export const getAgentsExecutions = (entity, queryParam) => fetchApi(`${entity}/filter?q=${escape(JSON.stringify(queryParam))}`, { method: 'GET' });

export const getResultExecutions = (entity, commandId) => fetchApi(`${entity}/filter?q={"offset":0,"limit":1,"filters":[{"name":"commands","op":"any","val":{"name":"id","op":"eq","val": ${commandId}}}]}`, { method: 'GET' });

export const deleteAgentsExecutions = (entity, data) => fetchApi(`${entity}`, { method: 'DELETE', data });

export const getAgentByFilters = (queryParam) => fetchApi(`agents/filter?q=${encodeURI(JSON.stringify(queryParam))}`);
export const getCloudAgentByFilters = (queryParam) => fetchApi(`cloud_agents/filter?q=${encodeURI(JSON.stringify(queryParam))}`);
